<template>
  <div
    ref="kt_modal_editar_vendedor_item"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_editar_vendedor_item"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/communication/com003.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Vendedor</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div class="col-md-8 fv-row mb-4">
              <label class="form-label">Vendedor</label>
              <div class="input-group mb-2">
                <input
                  type="text"
                  :id="`id_vendedor`"
                  v-model="this.nome"
                  class="form-control"
                  readonly
                />
                <span
                  class="svg-icon svg-icon-1 position-absolute end-0 mt-3"
                  @click="limparVendedorPedidoItem()"
                  :style="['margin-right: 4.50rem;']"
                >
                  <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                </span>
                <button
                  type="button"
                  class="input-group-text"
                  @click="modalVendedoresItem(true)"
                >
                  <span class="svg-icon svg-icon-2">
                    <inline-svg src="media/icons/duotune/general/gen004.svg" />
                  </span>
                </button>
              </div>
            </div>
            <div class="col-md-4 fv-row mb-4">
              <label class="form-label">Comissão %</label>
              <CurrencyInput
                id="txtComissao"
                class="form-control mb-2"
                placeholder="Peso Líquido"
                style="text-align: right"
                v-model="this.comissao"
                :options="options"
                @keydown.stop.prevent.enter="nextFocus(`btnConfirmar`)"
              ></CurrencyInput>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            type="button"
            id="btnConfirmar"
            class="btn btn-success svg-icon-white mb-2"
            data-bs-dismiss="modal"
            @click="confirmar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <VendedoresModal
    v-if="exibirVendedoresItem"
    @exibirModalVendedores="modalVendedoresItem"
    @selecionarVendedor="selecionarVendedorItem"
  ></VendedoresModal>
</template>

<script>
import { hideModal, getOrCreateInstanceModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import CurrencyInput from "@/components/text/CurrencyInput";
import VendedoresModal from "@/views/vendedores/VendedoresModal.vue";

export default {
  components: { CurrencyInput, VendedoresModal },
  emits: ["exibirModalVendedorItem", "confirmarVendedorItem"],
  props: {
    idVendedorItem: { type: Number, required: true },
    comissaoItem: { type: Number, required: true },
  },
  methods: {
    async confirmar() {
      this.$emit("confirmarVendedorItem", this.id_vendedor, this.comissao);
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_editar_vendedor_item);
      this.$emit("exibirModalVendedorItem", false);
    },
    modalVendedoresItem(exibir) {
      this.exibirVendedoresItem = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_vendedores_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarVendedores");
          },
          /*close*/ () => {
            this.modalVendedoresItem(false);
          }
        );
      }
    },
    selecionarVendedorItem(vendedor) {
      this.id_vendedor = vendedor.id;
      this.comissao = vendedor.comissao;
      this.nome = vendedor.nome.toUpperCase();
    },
    limparVendedorPedidoItem() {
      this.id_vendedor = null;
      this.comissao = 0;
      this.nome = "";
    },
  },
  async mounted() {
    this.loading = true;
    this.id_vendedor = this.idVendedorItem;
    this.comissao = this.comissaoItem;

    if (this.id_vendedor > 0) {
      var retOdata = await this.$store.dispatch(
        "vendedor/getVendedorOData",
        "?$select=nome&$filter=id eq " + this.id_vendedor
      );

      if (retOdata.value !== null && retOdata.value.length > 0) {
        this.nome = retOdata.value[0].nome;
      }
    }

    this.$utils.requestFocus("id_vendedor");
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      id_vendedor: 0,
      comissao: 0,
      nome: "",
      exibirVendedoresItem: false,
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #00000042;
}
</style>
